import { useAppConfig } from "@core/composables/data/useAppConfig";
import { authService } from "@core/services/authService";

export async function signOut(): Promise<void> {
  const { config } = useAppConfig();
  const redirectUrl = config.isImpersonatedUser ? "/dashboard/users" : "/";

  try {
    await authService.signOut();
  } catch (error) {
    console.error("Sign-out error:", error);
  }
  window.location.href = redirectUrl;
}
